declare var window: {
  _iub: {
    cs: {
      api: {
        openPreferences: () => void;
      };
    };
  };
};

export const useOpenCookieBanner = () => () =>
  window._iub.cs.api.openPreferences();
